// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z9R5","col":"styles_col__1CNR2"};